export const BLOCK_TYPES = {
  SITE: 'site',
  WORD: 'word',
  WORK_MODE: 'workMode',
  WHITE_LIST_BLOCK_LIST: 'whitelistBlockList',
  WHITE_LIST_WORK_MODE: 'whitelistWorkMode',
  CATEGORY: 'category',
  CONTEXT_MENU: 'contextMenu',
  CONTEXT_MENU_FOCUS_MODE: 'contextMenuFocusMode',
} as const;

export type BlockType = (typeof BLOCK_TYPES)[keyof typeof BLOCK_TYPES];

/**
 * Extract domain name from URL and convert to uppercase
 * e.g., "www.facebook.com" -> "FACEBOOK"
 */
export const parseWebsite = (website: string): string => {
  try {
    // Remove protocol if exists
    let domain = website.replace(/^https?:\/\//, '');
    // Remove www. prefix
    domain = domain.replace(/^www\./, '');
    // Get the first part before the TLD
    const parts = domain.split('.');
    // Return the first meaningful part (domain name without TLD)
    return (parts[0] || website).toUpperCase().trim();
  } catch {
    return website.toUpperCase().trim();
  }
};

const parseWord = (word: string): string => word.toUpperCase().trim();

export const DEFAULT_CHALLENGE_VALUE = 'BLOCKSITE';

export const CHALLENGE_VALUE: Record<
  string,
  string | ((value: string) => string)
> = {
  [BLOCK_TYPES.SITE]: parseWebsite,
  [BLOCK_TYPES.WORD]: parseWord,
  [BLOCK_TYPES.WORK_MODE]: parseWebsite,
  [BLOCK_TYPES.WHITE_LIST_BLOCK_LIST]: DEFAULT_CHALLENGE_VALUE,
  [BLOCK_TYPES.WHITE_LIST_WORK_MODE]: DEFAULT_CHALLENGE_VALUE,
  [BLOCK_TYPES.CATEGORY]: DEFAULT_CHALLENGE_VALUE,
  [BLOCK_TYPES.CONTEXT_MENU]: parseWebsite,
  [BLOCK_TYPES.CONTEXT_MENU_FOCUS_MODE]: parseWebsite,
} as const;

export interface BlockedImageResolutions {
  readonly high?: string;
  readonly medium?: string;
  readonly low?: string;
}

export interface BlockedImageResponse {
  readonly title: string;
  readonly resolutions: BlockedImageResolutions;
}

export interface BundlesImagesResponse {
  readonly bundleImages: readonly BlockedImageResponse[];
}

export interface BlockPageQueryParams {
  readonly word?: string;
  readonly blockType?: string;
  readonly category?: string;
  readonly site?: string;
}
